import * as React from 'react';

function SvgPriceTagFilled(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", d: "M21.42 2.59A1.984 1.984 0 0020.004 2h-5.488c-.36 0-.705.143-.96.397L2.584 13.365a2 2 0 000 2.827l5.223 5.223a2.001 2.001 0 002.827 0l10.967-10.964c.254-.255.397-.6.398-.96V4a1.976 1.976 0 00-.58-1.41zm-3.706 5.124a1.429 1.429 0 110-2.858 1.429 1.429 0 010 2.858z" })));
}

export default SvgPriceTagFilled;
